<template>
    <nav>
        <ul class="pagination">
            <li :class="{'disabled': current == 1}">
                <a href="javascript:;" @click="setCurrent(1)"> 首页 </a>
            </li>
            <li :class="{'disabled': current == 1}">
                <a href="javascript:;" @click="setCurrent(current - 1)">上一页</a>
            </li>
            <li v-for="p in grouplist" :class="{'active': current == p.val}">
                <a href="javascript:;" @click="setCurrent(p.val)"> {{ p.text }} </a>
            </li>
            <li :class="{'disabled': current == page}">
                <a href="javascript:;" @click="setCurrent(current + 1)">下一页</a>
            </li>
            <li :class="{'disabled': current == page}">
                <a href="javascript:;" @click="setCurrent(page)"> 尾页 </a>
            </li>
        </ul>
    </nav>
</template>

<script type="es6">
export default {
    name: 'paging',
    data() {
        return {
            current: this.currentPage
        }
    },
    props: {
        // 数据总条数
        total: {
            type: Number,
            default: 0
        },
        // 每页显示条数
        display: {
            type: Number,
            default: 10
        },
        // 当前页码
        currentPage: {
            type: Number,
            default: 1
        },
        // 分页条数
        pagegroup: {
            type: Number,
            default: 5,
            coerce: function (v) {
            v = v > 0 ? v : 5;
            return v % 2 === 1 ? v : v + 1;
            }
        },
        // 不是必须 搜索后默认第一页
        refresh: { 
            type: Boolean,
            default: false
        }
    },
    computed: {
        // 总页数
        page: function () { 
            return Math.floor(this.total / this.display);
        },
        // 获取分页页码
        grouplist: function () { 
            this.doRefresh();
            let len = this.page, temp = [], list = [], count = Math.floor(this.pagegroup / 2), center = this.current;
            if (len <= this.pagegroup) {
                while (len--) {
                    temp.push({text: this.page - len, val: this.page - len});
                }
                return temp;
            }
            while (len--) {
                temp.push(this.page - len);
            }
            let idx = temp.indexOf(center);
            (idx < count) && (center = center + count - idx);
            (this.current > this.page - count) && (center = this.page - count);
            temp = temp.splice(center - count - 1, this.pagegroup);
            do {
                let t = temp.shift();
                list.push({
                    text: t,
                    val: t
                });
            } while (temp.length);
            if (this.page > this.pagegroup) {
                (this.current > count + 1) && list.unshift({text: '...', val: list[0].val - 1});
                (this.current < this.page - count) && list.push({text: '...', val: list[list.length - 1].val + 1});
            }
            return list;
        }
    },
    mounted() {
        this.doRefresh()
    },
    methods: {
        doRefresh() {
            if (this.refresh) {
                this.current = 1
            }
        },
        setCurrent: function (idx) {
            if (this.current !== idx && idx > 0 && idx < this.page + 1) {
                this.current = idx;
                this.$emit('pagechange', this.current);
            }
        }
    }
}
</script>

<style scoped>
.pagination {
    font-family: "sans";
    overflow: hidden;
    display: table;
    margin: 0 auto;
    /*width: 100%;*/
    height: 50px;
  }

  .pagination li {
    float: left;
    height: 30px;
    border-radius: 5px;
    margin: 3px;
    color: #000000;
    background: white;
  }

  .pagination li :hover {
    background: #c40000;
    color: #fff;
  }

  .pagination li :hover a {
    color: #fff;
  }

  .pagination li a {
    display: block;
    width: 40px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-size: 12px;
    border-radius: 5px;
    text-decoration: none;
    color: black;
  }

  .pagination .active {
    background: #c40000;
  }

  .pagination .active a {
    color: #fff;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/paginate.vue